import getGroups from './getGroups'
import users from './common/users'
import subjects from './filters/subjects'

export default {
    data: {
        getProject: {
            subjects,
            groups: getGroups.data.getProject.groups,
            members: Object.keys(users).map((user) => {
                return { id: user.id, email: user.email }
            }),
        },
    },
}
